// src/Lexbuild/Studio.jsx
import React from "react";

export default function StudioPage() {
  return (
    <div style={{ height: "100vh", margin: 0, padding: 0 }}>
      <iframe
        src="https://nicolas2019-lextrackai.hf.space"
        title="LexTrackAI Studio"
        frameBorder="0"
        style={{ width: "100%", height: "90%", border: "none" }}
        allow="clipboard-write; microphone; camera; autoplay"
      />
    </div>
  );
}
